import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { FormGroupDirective } from '@directives/form-group.directive';
import { FeatureFlag, } from '@models';
import { QueueItemCommentService, } from '@services';
import UiValidators, { UI_COMMENT_MAX_LENGTH } from '@validators';
import { BehaviorSubject } from 'rxjs';
import { finalize, map, switchMap, } from 'rxjs/operators';
var TransactionDetailsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionDetailsModalComponent, _super);
    function TransactionDetailsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queueItem = _this.context.data;
        _this.activeTabName = 'Details';
        _this.loading$ = new BehaviorSubject(false);
        _this.reload$ = new BehaviorSubject(null);
        _this.queueItemComment = _this._injector.get(QueueItemCommentService);
        _this.comments$ = _this.reload$
            .pipe(switchMap(function () { return _this.queueItemComment
            .getByItem(_this.queueItem.id)
            .pipe(map(function (response) { return response.data; })); }));
        _this._appState = _this._injector.get(AppStateFacade);
        return _this;
    }
    TransactionDetailsModalComponent.prototype.ngOnInit = function () {
        this.formGroup = this._injector.get(FormBuilder).group({
            'text': [
                '',
                Validators.compose([
                    UiValidators.required(),
                    Validators.maxLength(UI_COMMENT_MAX_LENGTH),
                ]),
            ],
        });
        this.isQueueSchemaDefinitionsEnabled = this._appState.settings.isFeatureEnabled(FeatureFlag.QueueSchemaDefinitions);
    };
    TransactionDetailsModalComponent.prototype.ngOnDestroy = function () {
        this.reload$.complete();
        this.loading$.complete();
    };
    TransactionDetailsModalComponent.prototype.onSubmitComment = function (ev) {
        var _this = this;
        if (ev) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
        }
        this.loading$.next(true);
        var payload = {
            queueItemId: this.queueItem.id,
            text: this.formGroup.get('text').value.trim(),
        };
        this.queueItemComment
            .add(payload)
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            _this.reload$.next(null);
            _this.formDirective.resetForm();
        });
    };
    return TransactionDetailsModalComponent;
}(UiModalComponent));
export { TransactionDetailsModalComponent };
